import { Layout, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';

const StyledText = styled(Text)`
  margin-bottom: ${(props) => props.theme.size.static350};
`;

export function ModalContentVwView(): ReactElement {
  return (
    <Layout>
      <StyledText appearance={TokenTextAppearance.headline400} bold>
        Change Dealer
      </StyledText>
      <Text>
        Please note that by changing your dealer, your service-related information may become accessible to multiple Volkswagen authorised dealers.
        <br />
        <br />
        Access and use of this information will be strictly limited to fulfilling your service requests and enhancing customer support.</Text>
    </Layout>
  );
}
